export default __webpack_public_path__ + "static/media/BG-Red-0005.ee0d8222.png";